module.exports = __webpack_public_path__ + "media/images/official/special_hopper_toyoda_02-2e100f623af9cabc882bcffbfaaecad1.png";